import { i18nResponseDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';

export function getAttributes(
  language: LanguagesType,
  attributes: i18nResponseDto[] | undefined,
): { attributes: i18nResponseDto[] } | undefined {
  if (!attributes?.length) return undefined;

  const attributesToCreate: i18nResponseDto[] = attributes.map((attribute) => ({
    ...attribute,
    default: attribute[language],
  }));
  return { attributes: attributesToCreate };
}
